// extracted by mini-css-extract-plugin
export default {"symmetry_table":"SymmetryTable_symmetry_table__zCwte","accession_label":"SymmetryTable_accession_label__Br7Gr"};